import { useFormContext } from 'react-hook-form'
import BefehlFormAuftrag from '../Generic/BefehlFormAuftrag'
import { useTranslation } from 'react-i18next'

export interface Auftrag29_20FormProps {
  readOnly: boolean
  'data-testid': string
  activateEmptyFieldWarnings: boolean
}

export default function Auftrag29_20Form({
  readOnly,
  'data-testid': testId,
  activateEmptyFieldWarnings
}: Readonly<Auftrag29_20FormProps>) {
  const { control } = useFormContext()
  const { t } = useTranslation('ui-befehle')

  return (
    <BefehlFormAuftrag
      auftragKennung="29.20"
      label={t('auftraege.29_20.label')}
      fieldName="auftrag_29_20.enabled"
      control={control}
      readOnly={readOnly}
      testId={testId}
      activateEmptyFieldWarnings={activateEmptyFieldWarnings}
    >
      <span data-testid={`${testId}-text`}>{t('auftraege.29_20.label')}</span>
    </BefehlFormAuftrag>
  )
}
